import { keyframes } from "@emotion/react";
import { dimColors } from "./ProSimulator/ProSimulator";

// export const colors() = !dimColors ? {
//     BODY_COLOR_OFF:"#0a091a",
//     BODY_COLOR_ON:"#0cb7eb",
//     SPO2:"#009fe0",
//     O2:"#00ff00",
//     PULSE:"#ff6600",
//     COLORS_BACKGROUND_DEFAULT:"#000000",
//     COLORS_LAYOUT_BACKGROUND_NO_POWER:"#440000",
//     COLORS_CUSTOMPROFILE: "#ffff00",
//     COLORS_UNITS: "#666666",
//     COLORS_SUBITEM_DEFAULT: "#aaaaaa",
//     COLORS_DEFAULT_FALLBACK: "#ff00ff",
//     COLORS_ALARM_LOW: "#ffff00",
//     COLORS_ALARM_MEDIUM: "#ee9110",
//     COLORS_ALARM_HIGH: "#ff0000",
//     BODY_COLOR:"#494d4f",
//     BODY_BUTTON_COLOR:"#494D4F",
//     LAYOUT_PROFILE_TEXT_COLOR:"#aaaaaa",
//     MENU_SELECTED_COLOR:"#39d6d6",
//     TEXT_COLOR:"#FFFFFF"
    
// } : {
//     BODY_COLOR_OFF:"#0a091a",
//     BODY_COLOR_ON:"#0cb7eb",
//     SPO2:"#007bb0",
//     O2:"#009900",
//     PULSE:"#cc5200",
//     COLORS_BACKGROUND_DEFAULT:"#000000",
//     COLORS_LAYOUT_BACKGROUND_NO_POWER:"#220000",
//     COLORS_CUSTOMPROFILE: "#cccc00",
//     COLORS_UNITS: "#444444",
//     COLORS_SUBITEM_DEFAULT: "#666666",
//     COLORS_DEFAULT_FALLBACK: "#990099",
//     COLORS_ALARM_LOW: "#cccc00",
//     COLORS_ALARM_MEDIUM: "#bb700c",
//     COLORS_ALARM_HIGH: "#990000",
//     BODY_COLOR:"#494d4f",
//     BODY_BUTTON_COLOR:"#222324",
//     LAYOUT_PROFILE_TEXT_COLOR:"#666666",
//     MENU_SELECTED_COLOR:"#267676",
//     TEXT_COLOR:"#CCCCCC"    
// }

export const colors = () => {
  return !dimColors 
    ? {
      BODY_COLOR_OFF:"#0a091a",
      BODY_COLOR_ON:"#0cb7eb",
      SPO2:"#009fe0",
      O2:"#00ff00",
      PULSE:"#ff6600",
      COLORS_BACKGROUND_DEFAULT:"#000000",
      COLORS_LAYOUT_BACKGROUND_NO_POWER:"#440000",
      COLORS_CUSTOMPROFILE: "#ffff00",
      COLORS_UNITS: "#666666",
      COLORS_SUBITEM_DEFAULT: "#aaaaaa",
      COLORS_DEFAULT_FALLBACK: "#ff00ff",
      COLORS_ALARM_LOW: "#ffff00",
      COLORS_ALARM_MEDIUM: "#ee9110",
      COLORS_ALARM_HIGH: "#ff0000",
      BODY_COLOR:"#494d4f",
      BODY_BUTTON_COLOR:"#494D4F",
      LAYOUT_PROFILE_TEXT_COLOR:"#aaaaaa",
      MENU_SELECTED_COLOR:"#39d6d6",
      TEXT_COLOR:"#FFFFFF"
    } 
    : {
      BODY_COLOR_OFF:"#0a091a",
      BODY_COLOR_ON:"#0cb7eb",
      SPO2:"#007bb0",
      O2:"#009900",
      PULSE:"#cc5200",
      COLORS_BACKGROUND_DEFAULT:"#000000",
      COLORS_LAYOUT_BACKGROUND_NO_POWER:"#220000",
      COLORS_CUSTOMPROFILE: "#cccc00",
      COLORS_UNITS: "#444444",
      COLORS_SUBITEM_DEFAULT: "#666666",
      COLORS_DEFAULT_FALLBACK: "#990099",
      COLORS_ALARM_LOW: "#cccc00",
      COLORS_ALARM_MEDIUM: "#bb700c",
      COLORS_ALARM_HIGH: "#990000",
      BODY_COLOR:"#494d4f",
      BODY_BUTTON_COLOR:"#222324",
      LAYOUT_PROFILE_TEXT_COLOR:"#666666",
      MENU_SELECTED_COLOR:"#267676",
      TEXT_COLOR:"#CCCCCC"    
    }
}

export const blink = keyframes`
0% {
  opacity: 1;
}
50% {
  opacity: 1;
}
51% {
  opacity: 0;
}
100% {
  opacity: 0;
}
`;

export const loading = 
keyframes `
  to {
    clip-path: inset(0 -1ch 0 0)
  }
`;
